import { ColumnConfig, TurnoverInvoiceDetailsColumnKey } from '../../model';

export const turnoverInvoiceDetailsConfig: Record<
  TurnoverInvoiceDetailsColumnKey,
  ColumnConfig
> = {
  skuCode: {
    name: 'SKU Code',
    isComponent: true,
  },
  productName: {
    name: 'Product Name',
    isComponent: true,
  },
  hsn: {
    name: 'HSN',
    isComponent: true,
  },
  appliedScheme: {
    name: 'Applied Scheme',
    isComponent: true,
  },
  price: {
    name: 'Price',
    isComponent: true,
  },
  qty: {
    name: 'QTY',
    isComponent: true,
  },
  discountPercentage: {
    name: 'Discount Percentage',
    isComponent: true,
  },
  totalAmount: {
    name: 'Total Amount (Excl. Tax)',
    isComponent: true,
  },
  contributionAmount: {
    name: 'Contribution',
    alignment: 'flex-end',
    isComponent: true,
  },
  parsingStatus: {
    name: 'Parsing Status',
    isComponent: true,
  },
  remarks: {
    name: 'Remarks',
  },
  cgst: {
    name: 'CGST',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  sgst: {
    name: 'SGST',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  igst: {
    name: 'IGST',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  uom: {
    name: 'UOM',
    isVisible: false,
    isAdditional: true,
  },
  unit_price_with_tax: {
    name: 'Unit Price with Tax',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  secondary_discount: {
    name: 'Secondary Discount',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  cumulative_discount: {
    name: 'Cumulative Discount',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  discount_amount: {
    name: 'Discount Amount',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  gst_percentage: {
    name: 'GST Percentage',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  gst_amount: {
    name: 'GST Amount',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  total_amount_with_tax: {
    name: 'Total Amount (Incl. Tax)',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  taxable_value: {
    name: 'Taxable Value',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  header_discount_percentage: {
    name: 'Header Discount Percentage',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
  header_discount_amount: {
    name: 'Header Discount Amount',
    alignment: 'flex-end',
    isVisible: false,
    isAdditional: true,
  },
};
